import { render, staticRenderFns } from "./CompactIcon.vue?vue&type=template&id=a739725a&"
import script from "./CompactIcon.vue?vue&type=script&lang=js&"
export * from "./CompactIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports